/** React Query keys for the Connector admin page. One key per server list; tabs and stat cards share them. */
export const KEYS = {
  settings: ['admin', 'connector', 'settings'] as const,
  people: ['admin', 'connector', 'people'] as const,
  grants: ['admin', 'connector', 'grants', 'all'] as const,
  clients: ['admin', 'connector', 'clients'] as const,
  logs: ['admin', 'connector', 'logs', 'recent'] as const,
};
/** How many recent audit rows the page holds; filters run over this window. */
export const LOG_WINDOW = 500;
